module.exports = __webpack_public_path__ + "static/img/other.8a3fc725.png";